<template>
  <div>
    <Nav></Nav>
    <b-overlay :show="loadingReports" rounded="sm" spinner-type="grow">
      <b-container fluid>
        <b-row>
          <b-col>
            <h1>Reparto de Propinas — Detalle</h1>
            <p class="text-muted">Cada reparto con sus meseros aportantes y receptores. Presiona "Ver" para el desglose</p>
          </b-col>
        </b-row>

        <ReportSearchBar @search="searchRecv" @changed="filtersChanged"></ReportSearchBar>

        <b-card v-if="filtersHaveChanged" class="mt-5">
          <b-row>
            <b-col class="text-center py-5">
              <b-icon icon="search" font-scale="3" variant="primary"></b-icon>
              <h4 class="mt-3">Filtros modificados</h4>
              <p class="text-muted">Presiona el botón "Buscar" para actualizar el reporte</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-5" v-else-if="reportTable.length > 0 && !filtersHaveChanged">
          <b-row class="mb-4">
            <b-col md="4" sm="6" class="mb-3">
              <b-card bg-variant="primary" text-variant="white">
                <h4>{{ activeCount }}</h4>
                <small>Repartos Activos</small>
              </b-card>
            </b-col>
            <b-col md="4" sm="6" class="mb-3">
              <b-card bg-variant="success" text-variant="white">
                <h4>${{ totalCollected.toFixed(2) }}</h4>
                <small>Propina Recaudada</small>
              </b-card>
            </b-col>
            <b-col md="4" sm="6" class="mb-3">
              <b-card bg-variant="warning" text-variant="white">
                <h4>${{ totalDistributed.toFixed(2) }}</h4>
                <small>Total Repartido</small>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <b-table
                small
                striped
                hover
                :items="reportTable"
                :fields="tableFields"
                responsive
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #cell(created_at)="data">{{ formatDate(data.value) }}</template>
                <template #cell(total_tips_collected)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(total_to_distribute)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(point_value)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(sales_percentage_of_shift)="data">{{ (data.value || 0).toFixed(1) }}%</template>
                <template #cell(status)="data">
                  <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                    {{ data.value === 1 ? 'Activo' : 'Cancelado' }}
                  </b-badge>
                </template>
                <template #cell(actions)="row">
                  <b-button size="sm" variant="outline-primary" @click="row.toggleDetails">
                    {{ row.detailsShowing ? 'Ocultar' : 'Ver' }}
                  </b-button>
                </template>

                <template #row-details="row">
                  <b-card>
                    <b-row>
                      <b-col lg="7">
                        <h6>Aportantes</h6>
                        <b-table small bordered :items="row.item.sources || []" :fields="sourceFields">
                          <template #cell(total_sales)="d">${{ (d.value || 0).toFixed(2) }}</template>
                          <template #cell(total_tips)="d">${{ (d.value || 0).toFixed(2) }}</template>
                          <template #cell(percentage)="d">{{ (d.value || 0).toFixed(1) }}%</template>
                          <template #cell(amount_to_distribute)="d">${{ (d.value || 0).toFixed(2) }}</template>
                          <template #cell(waiter_remainder)="d">${{ (d.value || 0).toFixed(2) }}</template>
                        </b-table>
                      </b-col>
                      <b-col lg="5">
                        <h6>Receptores</h6>
                        <b-table small bordered :items="row.item.recipients || []" :fields="recipientFields">
                          <template #cell(amount)="d">${{ (d.value || 0).toFixed(2) }}</template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-else-if="!loadingReports && !filtersHaveChanged" class="mt-5">
          <b-row>
            <b-col class="text-center py-5">
              <b-icon icon="info-circle" font-scale="3" variant="secondary"></b-icon>
              <h4 class="mt-3">No hay datos disponibles</h4>
              <p class="text-muted">Selecciona un rango de fechas y sucursales para ver el reporte</p>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import axios from "axios";
import moment from "moment";
import ReportSearchBar from "./searchBar/ReportSearchBar.vue";

export default {
  name: "TipDistributionDetail",
  components: { Nav, ReportSearchBar },
  data() {
    return {
      loadingReports: false,
      reportTable: [],
      filtersHaveChanged: false,
      dates: {
        initial_date: "",
        end_date: "",
        sucursales: [],
      },
      sortBy: "created_at",
      sortDesc: true,
      tableFields: [
        { key: "created_at", label: "Fecha", sortable: true },
        { key: "sucursal_name", label: "Sucursal", sortable: true },
        { key: "shift_id", label: "Turno", sortable: true },
        { key: "total_tips_collected", label: "Recaudada", sortable: true },
        { key: "total_to_distribute", label: "Repartido", sortable: true },
        { key: "total_points", label: "Puntos", sortable: true },
        { key: "point_value", label: "Valor/Punto", sortable: true },
        { key: "sales_percentage_of_shift", label: "% Ventas Turno", sortable: true },
        { key: "status", label: "Estado", sortable: true },
        { key: "actions", label: "Detalle" },
      ],
      sourceFields: [
        { key: "waiter_name", label: "Mesero" },
        { key: "total_sales", label: "Ventas" },
        { key: "total_tips", label: "Propina" },
        { key: "percentage", label: "%" },
        { key: "amount_to_distribute", label: "Aporta" },
        { key: "waiter_remainder", label: "Retiene" },
      ],
      recipientFields: [
        { key: "waiter_name", label: "Mesero" },
        { key: "points", label: "Puntos" },
        { key: "amount", label: "Recibe" },
      ],
    };
  },
  computed: {
    activeCount() {
      return this.reportTable.filter((i) => i.status === 1).length;
    },
    totalCollected() {
      return this.reportTable.filter((i) => i.status === 1).reduce((s, i) => s + (i.total_tips_collected || 0), 0);
    },
    totalDistributed() {
      return this.reportTable.filter((i) => i.status === 1).reduce((s, i) => s + (i.total_to_distribute || 0), 0);
    },
  },
  methods: {
    formatDate(v) {
      return v ? moment(v).format("YYYY-MM-DD HH:mm") : "";
    },
    filtersChanged() {
      this.filtersHaveChanged = true;
    },
    searchRecv(p) {
      this.dates.initial_date = moment(p.initDate).format("YYYY-MM-DD") + " 00:00:00";
      this.dates.end_date = moment(p.endDate).format("YYYY-MM-DD") + " 23:59:59";
      this.dates.sucursales = p.sucursales;
      this.filtersHaveChanged = false;
      this.getReport();
    },
    getReport() {
      this.loadingReports = true;
      let that = this;
      this.reportTable = [];
      axios
        .post("/report/tips/distributions", this.dates)
        .then(function (response) {
          that.reportTable = response.data || [];
        })
        .catch(function (err) {
          that.makeToast("Error", err.response?.data || "Error al cargar el reporte", "danger");
        })
        .finally(() => {
          that.loadingReports = false;
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>

<style scoped>
.b-table th {
  white-space: nowrap;
}
</style>
